import React, { useEffect } from "react";
import { useHistory, useParams } from "react-router";
import { useSelector } from "react-redux";
import { unwrapResult } from "@reduxjs/toolkit";
import { Button, Card, Form, Space, Spin } from "antd";
import { message } from "components";
import { RootState, useAppDispatch } from "app/store";
import useAppAuth0 from "hooks/useAppAuth0";
import AccessControlForm, { AccessControlFormProps } from "../AccessControlForm";
import { emailDomainSelectors, fetchEmailDomain, updateEmailDomain } from "../accessControlSlice";

function AccessControlDetail() {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { domainId } = useParams<{ domainId: string }>();
  const { user } = useAppAuth0();
  const isLoading = useSelector((state: RootState) => state.loading);
  const domain = useSelector((state: RootState) => emailDomainSelectors.selectById(state, domainId));
  const [form] = Form.useForm();

  useEffect(() => {
    dispatch(fetchEmailDomain(Number(domainId)))
      .then(unwrapResult)
      .catch(() => history.push("/customers/access-control"));
  }, [dispatch, domainId, history]);

  function goBackToList() {
    history.push("/customers/access-control");
  }

  const handleSubmit: AccessControlFormProps["onFinish"] = (values) => {
    dispatch(updateEmailDomain({ id: Number(domainId), ...values }))
      .then(unwrapResult)
      .then(goBackToList)
      .catch(message.error);
  };

  const cardExtra = (
    <Space>
      <Button type="default" shape="round" onClick={goBackToList}>
        Cancel
      </Button>
      {user.canUpdateEmailDomain && (
        <Button type="primary" shape="round" onClick={form.submit}>
          Save
        </Button>
      )}
    </Space>
  );

  return (
    <Card title="Edit domain" extra={cardExtra} className="page-container">
      <Spin spinning={isLoading} size="large">
        <AccessControlForm form={form} data={domain} onFinish={handleSubmit} />
      </Spin>
    </Card>
  );
}

export default AccessControlDetail;
